

import { Cookies } from 'react-cookie';
import { useEffect, useState} from "react";
import * as XLSX from 'xlsx';
import { GroupMasterTable, setFocus, setTitle } from "../Common/Common";
import { post } from "../Common/service";
import { ExportData } from '../Exports/Export';
import Loader from '../Layout/Loader';
import { API_SERVER } from '../../EnvConfig/env_config';
import { AlertBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
const cookies = new Cookies();

const GroupMasterForm = ({ open, setOpen }) => {
    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [ColoredRow, setColoredRow] = useState(null);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const navigate = useNavigate();
    const [MenuText, setMenuText] = useState("Group Master");
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
        PageIndex: "1",
    })
    const [formData, setFormData] = useState({
        UserGroupID: '',
        GroupName: '',
        Active: true
    });

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const Source = 'web';

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode').toString(),
            Source: 'web',
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/User/ShowUserGroupMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setTableData(res)
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }
            setIsLoading(false)
        })
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevformdata) => ({ ...prevformdata, [name]: value }));
    }

    const handleClear = () => {
        setFormData({
            GroupName: '',
            UserGroupID: '',
            Active: true,
        })
        filterData.SearchText = ''
        setColoredRow(null)
        setEdit(false)
        getGroupMasterData()
    }

    const handleSubmit = async () => {
        const loginUserCode = String(LoginUserCode)
        let data = {
            ...formData, Token, LoginUserCode: loginUserCode, Source
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/User/InsertUpdateUserGroupMaster`, { ...data }, (res) => {
            if (res.status === "SUCCESS") {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus);

                handleClear();
                setIsLoading(false)
                setEdit(false);
                setColoredRow(null)
                getGroupMasterData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus);
            }
        })
        setIsLoading(false)
    };

    const handleEditData = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode').toString(),
            Source: 'web',
            UserGroupID: id
        }
        post(`${API_SERVER}/api/User/EditUserGroupMaster`, { ...data }, (res) => {

            setEdit(true)
            if (res.status === 'SUCCESS') {
                setColoredRow(id)
                 setFormData({ ...formData, UserGroupID: id, GroupName: res.groupName, Active: res.active });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }
        })
    }
    const handleDelete = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode').toString(),
            Source: 'web',
            UserGroupID: id
        }
        post(`${API_SERVER}/api/User/DeleteUserGroupMaster`, { ...data }, (res) => {
            if (res.status === "SUCCESS") {
                AlertBox(res.status, res.message, res.focus);

            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }
            handleClear()
            getGroupMasterData();
        })
       
    }
    const getSearchingList = async () => {
        const loginUserCode = String(LoginUserCode)
        let data = {
            Token, LoginUserCode: loginUserCode, PageName: 'GroupMaster'
        }
        post(`${API_SERVER}/api/Dashboard/BindSearchingColumnList`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                let list = res.getSearchingList
                setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
                setFilterList(res.getSearchingList)
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);

            }

        })
    };
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getGroupMasterData();
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hGroupName,
            records.hActive, records.hCreatedBy, records.hCreatedDate, records.hCreatedByIPAddress, records.hModifiedBy, records.hModifiedDate, records.hModifiedByIPAddress]
            ,
            ...records.getData.map((records) => [records.srNo, records.groupName,
            records.active, records.createdBy, records.createdDate, records.createdByIPAddress, records.modifiedBy, records.modifiedDate, records.modifiedByIPAddress
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'GroupMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `${API_SERVER}/api/User/ShowUserGroupMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode').toString(),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };


    useEffect(() => {
        getGroupMasterData()
        setTitle('GroupMaster', setOpen);
        getSearchingList()
        setFocus("txtGroupName")
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    return (
        <>
            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div className="fields">
                                            <label className="form-label">Group Name <span className="Required">*</span></label>
                                                <input
                                            id="txtGroupName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Group Name"
                                                autoComplete="off"
                                                maxLength='30'
                                                name='GroupName'
                                                value={formData.GroupName}
                                                onChange={handleChange}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') { setFocus("activeCheckbox") };
                                                    }}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"
                                                name='Active'
                                                checked={formData.Active}
                                                onChange={(e) => setFormData({ ...formData, Active: e.target.checked })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="lms-new-button text-center">
                                            {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id="btnSave"onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update & Save
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </section>
                <GroupMasterTable  handleReset={handleClear} ColoredRow={ColoredRow} setColoredRow={setColoredRow} searchHandle={searchHandle} handleChange={handleChange1} currentPageNo={currentPageNo} filterList={filterList} filterData={filterData} setFilterData={setFilterData} tableData={tableData} getGroupMasterData={getGroupMasterData} handleEditData={handleEditData} handleDelete={handleDelete} />
                
                {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            
            </main>
        </>
    )
}
export default GroupMasterForm